/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.ts to modify the generation of this file.
const config = {};
config.sitecoreApiKey = process.env.SITECORE_API_KEY || "{83B432B0-3E2B-41D5-BA34-46569D0C743D}",
config.sitecoreApiHost = process.env.SITECORE_API_HOST || "https://sitecoredxp-dev.osfhealthcare.org/",
config.jssAppName = process.env.JSS_APP_NAME || "osfhealthcare",
config.graphQLEndpointPath = process.env.GRAPH_QL_ENDPOINT_PATH || "/sitecore/api/graph/edge",
config.graphQLEndpoint = process.env.GRAPH_QL_ENDPOINT || `${config.sitecoreApiHost}${config.graphQLEndpointPath}`;
module.exports = config;